import React, { useState, useEffect } from "react";
import CarCard from "../CarList/CarCard";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import car1 from "../../assets/assets/images/home_images/home_grid1.png";
import car2 from "../../assets/assets/images/home_images/home_grid2.png";
import car3 from "../../assets/assets/images/home_images/home_grid3.png";
import car4 from "../../assets/assets/images/home_images/home_grid4.png";
import { useSelector } from "react-redux";
import noData from "../../assets/no-data.png";
const Carousal = () => {
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const getCartData = useSelector((state) => state?.car?.getCartData);
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const loginDetail = useSelector((state) => state?.auth?.loginId);
  const [filteredData, setFilterData] = useState([]);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 767 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 1,
    },
  };
  function checkUncheckfav(id) {
    const data = filteredData?.map((ele) => {
      if (ele?._id === id) {
        if (!Array.isArray(ele.isUserFavId)) {
          ele.isUserFavId = [];
        }

        const userId = userDetail?.data?._id;
        const userIndex = ele.isUserFavId.indexOf(userId);

        let newIsUserFavId;
        if (userIndex !== -1) {
          // Remove userId if it exists
          newIsUserFavId = ele.isUserFavId.filter((uid) => uid !== userId);
        } else {
          // Add userId if it doesn't exist
          newIsUserFavId = [...ele.isUserFavId, userId];
        }

        return {
          ...ele,
          isUserFavId: newIsUserFavId,
        };
      }

      return ele;
    });
    setFilterData(data);
  }

  useEffect(() => {
    // if (loginDetail) {
    //     const data = getCartData?.data?.filter((element) => {
    //         return userDetail?.data?._id !== element?.userId;
    //     });
    //     setFilterData(data)
    // }
    // else (
    //     setFilterData(getCartData?.data)
    // )
    const data = getCartData?.data?.filter((element) => {
      if (loginDetail) {
        return userDetail?.data?._id !== element?.userId;
      } else {
        return element;
      }
    });
    setFilterData(data);
  }, [getCartData]);

  return (
    <div className="container my-6" name="searchResult">
      <div className="mb-5">
        <h1 className="text-center accentColor font">Our Vehicle Fleet</h1>
        <p className="text-secondary text-center">
          Explore our fleet and book your car now to enjoy your journey!{" "}
        </p>
      </div>
      {/* <Carousel showDots={true} responsive={responsive}>
                {getCartData?.data?.length > 0 ? (
                    getCartData?.data?.map((element, index) => (
                        <div className='pb-5 mx-2' key={element._id}>
                            <CarCard
                                available="true"
                                image={`${baseURL}${element.frontImage}`}
                                carName={element.maker.carMake}
                                rating={`${element.averageRating}`}
                                seater={element.numberOfSeats}
                                price={element.pricePerDay}
                                data={element}
                            />
                        </div>
                    ))
                ) : (
                    <div>Loading or no data available...</div>
                )}
            </Carousel> */}
      {filteredData?.length >= 1 ? (
        <>
          <Carousel
            // showDots={true}
            responsive={responsive}
          >
            {filteredData?.map((element, index) => {
              // if (userDetail?.data?._id !== element?.userId) {
              return (
                <div className="pb-5 mx-2" key={element._id}>
                  <CarCard
                    checkUncheckfav={checkUncheckfav}
                    available="true"
                    image={`${baseURL}${element.frontImage}`}
                    carName={element.maker.carMake}
                    rating={`${element.averageRating}`}
                    seater={element.numberOfSeats}
                    price={element.pricePerDay}
                    data={element}
                  />
                </div>
              );

              // }
            })}
          </Carousel>
        </>
      ) : (
        <div className="d-flex justify-content-center">
          {/* <h1 className="text-center text-secondary ">
            Loading or no data available...
          </h1> */}
          <img src={noData} alt="no data found" className="nofoundImg" />
        </div>
      )}

      {/* <Carousel showDots={true} responsive={responsive}>
                {getCartData?.data?.map((element, index) => (
                    <div className='pb-5 mx-2' key={element?._id} >
                        <CarCard
                            available="true"
                            image={`${baseURL}${element?.frontImage}`}
                            carName={element?.maker?.carMake}
                            rating={`${element?.averageRating}`}
                            seater={element?.numberOfSeats}
                            price={element?.pricePerDay}
                            data={element}
                        />
                    </div>
                ))}
            </Carousel> */}
    </div>
  );
};

export default React.memo(Carousal);
